// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-item:focus, .dropdown-item:hover  ,.dropdown-item:hover > .text-black {

  color: white !important;
  background-color: #ff6036 !important;

}
.sidebar-main {
  display: flex;
  flex-direction: column;
  padding: 20px 25px;
  width: 100%;
  height: 100vh;
  gap: 25px;
  overflow-y: scroll;
}
.sidebar-main .logo-part {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
}
.sidebar-main .btn-add {
  all: unset;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  padding: 15px 15px;
  background-color: #ff6036;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: white;
  border-radius: 12px;
  transition: all ease 0.3s;
  border-radius: 8px;
}
.sidebar-main .btn-add:hover {
  opacity: 0.9;
  transform: scale(0.98);
}
.sidebar-main .nav-part {
  display: flex;
  flex-direction: column;
  height: 60%;
  align-items: flex-start;
  justify-content: space-between;
  /* padding-left: 5px; */
}
.sidebar-main .nav-part .bottom-logoutpart {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
}
.sidebar-main .nav-part .bottom-logoutpart .logout-btn,
.sidebar-main .nav-part .top-navpart .nav-btn {
  all: unset;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  color: black;
  background: transparent;
}
.sidebar-main .nav-part .icon {
  width: 18px;
}
.sidebar-main .nav-part .text {
  font-size: 16px;
  margin: 0;
}
.sidebar-main .nav-part .top-navpart {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 20px;
}
.sidebar-main .nav-part .top-navpart .nav-btn.active .text {
    color: #ff6036;
}

.heart > svg{
  fill: #ff6036;
} 

.dropdown-item .active{
  background-color: #ff6036 !important;
}


.sidebar-main .publicpART  .text{
   color:gray;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/sidebar.css"],"names":[],"mappings":"AAAA;;EAEE,uBAAuB;EACvB,oCAAoC;;AAEtC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;AACA;;EAEE,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;AACX;AACA;IACI,cAAc;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;;AAGA;GACG,UAAU;AACb","sourcesContent":[".dropdown-item:focus, .dropdown-item:hover  ,.dropdown-item:hover > .text-black {\r\n\r\n  color: white !important;\r\n  background-color: #ff6036 !important;\r\n\r\n}\r\n.sidebar-main {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px 25px;\r\n  width: 100%;\r\n  height: 100vh;\r\n  gap: 25px;\r\n  overflow-y: scroll;\r\n}\r\n.sidebar-main .logo-part {\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: flex-start;\r\n  justify-content: flex-start;\r\n}\r\n.sidebar-main .btn-add {\r\n  all: unset;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  padding: 15px 15px;\r\n  background-color: #ff6036;\r\n  font-size: 14px;\r\n  font-weight: 600;\r\n  line-height: 20px;\r\n  color: white;\r\n  border-radius: 12px;\r\n  transition: all ease 0.3s;\r\n  border-radius: 8px;\r\n}\r\n.sidebar-main .btn-add:hover {\r\n  opacity: 0.9;\r\n  transform: scale(0.98);\r\n}\r\n.sidebar-main .nav-part {\r\n  display: flex;\r\n  flex-direction: column;\r\n  height: 60%;\r\n  align-items: flex-start;\r\n  justify-content: space-between;\r\n  /* padding-left: 5px; */\r\n}\r\n.sidebar-main .nav-part .bottom-logoutpart {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n}\r\n.sidebar-main .nav-part .bottom-logoutpart .logout-btn,\r\n.sidebar-main .nav-part .top-navpart .nav-btn {\r\n  all: unset;\r\n  cursor: pointer;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  gap: 15px;\r\n  color: black;\r\n  background: transparent;\r\n}\r\n.sidebar-main .nav-part .icon {\r\n  width: 18px;\r\n}\r\n.sidebar-main .nav-part .text {\r\n  font-size: 16px;\r\n  margin: 0;\r\n}\r\n.sidebar-main .nav-part .top-navpart {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  gap: 20px;\r\n}\r\n.sidebar-main .nav-part .top-navpart .nav-btn.active .text {\r\n    color: #ff6036;\r\n}\r\n\r\n.heart > svg{\r\n  fill: #ff6036;\r\n} \r\n\r\n.dropdown-item .active{\r\n  background-color: #ff6036 !important;\r\n}\r\n\r\n\r\n.sidebar-main .publicpART  .text{\r\n   color:gray;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
